<template>
    <div class="export-statistics-view">
        <v-main>
            <year-month-range-picker v-model="period" @valid="onValid" />
            <v-row>
                <v-col>
                    <v-btn color="primary" :disabled="!valid" @click="download"> Last ned statistikk (.xlsx) </v-btn>
                </v-col>
            </v-row>
        </v-main>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { container } from 'inversify-props';
import YearMonthRangePicker from './components/YearMonthRangePicker.vue';
import { useStatisticsStore } from './statisticsStore';
import { IStatisticsService, IStatisticsServiceId } from '@/features/statistics/IStatisticsService';

const store = useStatisticsStore();
const period = ref({ from: store.monthlyPeriod.from, to: store.monthlyPeriod.to });
const valid = ref(true);

function onValid(v: boolean) {
    valid.value = v;
}

function download() {
    if (!valid.value) return;
    const service = container.get<IStatisticsService>(IStatisticsServiceId);
    const from = period.value.from + '-01';
    const to = toLastDay(period.value.to);
    const url = service.getExportUrl(from, to);
    const a = document.createElement('a');
    a.href = url;
    a.click();
}

function toLastDay(yearMonth: string): string {
    const [y, m] = yearMonth.split('-').map(Number);
    const d = new Date(y, m, 0);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}
</script>
